import {
	ORDER_FAILED,
	ORDER_SUCCESS,
	CLEAR_ORDER,
	GET_ORDER_SUCCESS,
	GET_ORDER_FAILED,
	GET_ADMIN_ORDER_SUCCESS,
	GET_ADMIN_ORDER_FAILURE,
	GET_ADMIN_ORDER_REQUEST,
	GET_ONE_ORDER_SUCCESS,
	GET_ONE_ORDER_FAILURE,
} from '../actions/index';

const initialState = {
	order: null,
	orders: [],
	loading: true,
	ordersloading: true,
	adminorder: [],
	adminorderloading: true,
	userorder: null,
	userloading: true,
};

const orderReducer = (state = initialState, action) => {
	switch (action.type) {
		case ORDER_SUCCESS:
			return {
				...state,
				order: action.payload,
				loading: false,
			};

		case ORDER_FAILED:
			return {
				...state,
				order: null,
				loading: false,
			};
		case CLEAR_ORDER:
			return { ...state, order: null, loading: false };
		case GET_ORDER_SUCCESS:
			return {
				...state,
				orders: action.payload,
				ordersloading: false,
			};
		case GET_ORDER_FAILED:
			return {
				...state,
				orders: null,
				ordersloading: false,
			};
		case GET_ADMIN_ORDER_REQUEST:
			return {
				...state,
				adminorderloading: true,
			};
		case GET_ADMIN_ORDER_SUCCESS:
			return {
				...state,
				adminorder: action.payload,
				adminorderloading: false,
			};
		case GET_ADMIN_ORDER_FAILURE:
			return {
				...state,
				adminorder: null,
				adminorderloading: false,
			};
		case GET_ONE_ORDER_SUCCESS:
			return {
				...state,
				userorder: action.payload,
				userloading: false,
			};
		case GET_ONE_ORDER_FAILURE:
			return {
				...state,
				userorder: null,
				userloading: false,
			};
		default:
			return state;
	}
};

export default orderReducer;
